import React from "react";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import { useJwt } from "react-jwt";
import Select from "react-select";
import { FaStar } from "react-icons/fa";
import {
  CreateBanner,
  GetProductStatus,
  GetWedgetTitle,
} from "../apiconfig/authService";
import { toast } from "react-toastify";
import { RiLoaderFill } from "react-icons/ri";

function AddBanner(props) {
  const navigate = useNavigate();
  const { _, isExpired } = useJwt(localStorage.getItem("accessToken"));
  if (isExpired) navigate("/");

  const setMediaTableViewMessage = props.setMessage;

  const [mediaTitle, setMediaTitle] = useState("");
  const [mediaImage, setMediaImage] = useState(null);
  const [statusid, setStatusid] = useState(1);
  const [statusData, setStatusData] = useState(null);
  const [serialNumber, setSerialNumber] = useState("");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [sliderData, setSliderData] = useState([]);
  const [totalSliders, setTotalSliders] = useState(0);
  const [message, setMessage] = useState("");
  const [refetchData, setRefetchData] = useState(false);

  const [widget, setWidget] = useState();
  const [isMessageRed, setIsMessageRed] = useState("");
  const [loading, setLoading] = useState(false);

  const handleTitleChange = (e) => {
    setMediaTitle(e.target.value);
  };
  const handleSerialNUmber = (e) => {
    setSerialNumber(e.target.value);
  };

  // console.log('mediaImage',mediaImage)
  const handleImageChange = (e) => {
    setMediaImage(e.target.files[0]);
  };

  const handleStatusIdChange = (e) => {
    setStatusid(e.target.value);
  };
  const handleWidgetChange = (e) => {
    setWidget(e.target.value);
  };

  useEffect(() => {
    (async () => {
      try {
        const sliderResponse = await GetWedgetTitle(
          page,
          itemsPerPage,
          search,
          localStorage.getItem("accessToken")
        );
        setSliderData(sliderResponse.data.items);
        setPageCount(Math.ceil(sliderResponse.data.pagination.pageCount));
        setTotalSliders(sliderResponse.data.pagination.count);
      } catch (error) {
        console.log(error);
      }
    })();
  }, [page, itemsPerPage, refetchData]);

  const handleSubmitClick = async (e) => {
    e.preventDefault();

    try {
      if (!mediaTitle.trim()) {
        toast.error("Banner title is required!");
        return;
      }
      if (mediaImage === null) {
        toast.error("Banner image is required!");
        return;
      }
      if (serialNumber === "") {
        toast.error("Serial Number is required!");
        return;
      }
      if (!widget ||  widget.length === 0) {
        toast.error("Wedget is required!");
        return;
      }
    } catch (error) {
      toast.error(error.message);
      window.scrollTo(0, 0);
      return;
    }

    const formData = new FormData();
    formData.append("title", mediaTitle);
    formData.append("Image", mediaImage);
    formData.append("statusid", statusid);
    formData.append("serialNumber", serialNumber);

    // Add each selected widget ID
    widget.forEach((id) => formData.append("widgets[]", id));

    try {
      setLoading(true);
      const response = await CreateBanner(
        formData,
        localStorage.getItem("accessToken")
      );

      if (response.status === 201) {
        setLoading(false);
        toast.success("Banner Added Successfully");
        setMediaTableViewMessage(response.data.message);
        navigate("/banner");
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        toast.error(err.response.data.error);
        window.scrollTo(0, 0);
      } else {
        toast.error("An error occurred. Please try again later.");
        window.scrollTo(0, 0);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const statusResponse = await GetProductStatus(
          localStorage.getItem("accessToken")
        );
        setStatusData(statusResponse.data);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  return (
    <div className="dashboard-content">
      <Sidebar />
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Add Banner</h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/banner" className="btn btn-primary">
              View All
            </NavLink>
          </div>
        </div>

        <div
          role="tabpanel"
          className="personal-info tab-pane active storetab"
          id="pi"
        >
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="d-flex">
                <label htmlFor="catName">Title </label>
                <FaStar size={7} className="text-danger" />
              </div>
              <input
                type="text"
                value={mediaTitle}
                onChange={handleTitleChange}
                className="form-control custom-input my-2"
                id="catName"
                placeholder="Title"
              />
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="d-flex">
                <label htmlFor="catImg">Image</label>
                <FaStar size={7} className="text-danger" />
              </div>
              <input
                type="file"
                className="form-control custom-input my-2"
                onChange={handleImageChange}
                id="catImg"
                placeholder="Image"
              />
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Status</label>
              <select
                className="form-select custom-input my-2"
                onChange={handleStatusIdChange}
                value={statusid}
              >
                {statusData?.map((item, index) => (
                  <option value={item.statusid} key={index}>
                    {item.status}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="d-flex">
                <label htmlFor="catName">Serial Number</label>
                <FaStar size={7} className="text-danger" />
              </div>
              <input
                type="text"
                value={serialNumber}
                onChange={handleSerialNUmber}
                className="form-control custom-input my-2"
                id="catName"
                placeholder="Serial"
              />
            </div>
          </div>
          <div className="form-group col-sm-12 col-lg-12 mb-3">
            <div className="d-flex">
              <label htmlFor="floatingInput">Widgets</label>
              <FaStar size={7} className="text-danger" />
            </div>
            <Select
              isMulti
              options={sliderData.map((item) => ({
                value: item._id,
                label: item.title,
              }))} // Convert sliderData to options
              onChange={(selectedOptions) => {
                setWidget(selectedOptions.map((option) => option.value)); // Extract selected IDs
              }}
              value={sliderData
                .filter((item) => widget?.includes(item._id))
                .map((item) => ({ value: item._id, label: item.title }))} // Map selected widgets to value format
              className="basic-multi-select"
              classNamePrefix="select"
            />
          </div>

          <div className="row">
            <div className="col-12" style={{ height: "40px", width: "80px" }}>
              {loading ? (
                <div
                  className="btn btn-primary loader-active save-btn"
                  style={{ height: "100%", width: "100%" }}
                >
                  <RiLoaderFill
                    size={20}
                    className="spin-animation"
                    color="white"
                  />
                </div>
              ) : (
                <button
                  type="submit"
                  onClick={handleSubmitClick}
                  disabled={loading}
                  className="btn btn-primary save-btn text-uppercase"
                  style={{ height: "100%", width: "100%" }}
                >
                  Add
                </button>
              )}
            </div>
          </div>
        </div>
        <hr />
      </div>
    </div>
  );
}
export default AddBanner;
